import { Component, inject, Input, OnInit } from '@angular/core'
import Class from '@account/Class'
import { SystemConfigService } from '@account/Services/SystemConfigService'
import { NgStyle } from '@angular/common'
import { DateTimeComponent } from '@account/Components/ui/DateTime/DateTimeComponent'
import { CurrencyComponent } from '@account/Components/ui/Currency/CurrencyComponent'
import { OrderItemService } from '@account/Services/OrderItemService'
import { PermissionsService } from '@account/Services/PermissionsService'

@Component({
	selector: 'class-info',
	templateUrl: './ClassInfo.Component.html',
	imports: [DateTimeComponent, CurrencyComponent, NgStyle, DateTimeComponent],
})
export class ClassInfoComponent implements OnInit {
	@Input() public class: Class

	public formattedType: string

	public formattedMinAge: string

	public formattedState: string

	public formattedEntryType: string

	public currentTotalCapacity: number | null = null

	public readonly systemConfigService: SystemConfigService

	public isLoggedIn: boolean = false

	private readonly orderItemsService: OrderItemService

	constructor() {
		this.systemConfigService = inject(SystemConfigService)
		this.orderItemsService = inject(OrderItemService)

		const permissions = inject(PermissionsService)
		this.isLoggedIn = permissions.account !== undefined
	}

	public ngOnInit() {
		this.formattedType = this.class.formattedType()
		this.formattedMinAge = this.class.getAgeRange()
		this.formattedState = this.class.getCurrentStatus(
			this.systemConfigService.config.timezone,
		)
		this.formattedEntryType = this.class.getFormattedEntryType()
		if (this.isLoggedIn) {
			this.getCurrentTotalCapacity()
		}
	}

	private readonly getCurrentTotalCapacity = async (): Promise<void> => {
		this.currentTotalCapacity =
			await this.orderItemsService.getTotalEntriesCount()
	}
}
